module.exports = __webpack_public_path__ + "img/appAsset--alerts-ax.00183f6b.svg";